var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dot-line[data-v-017174d1] {\n  height: 10px;\n  width: 100%;\n  background-image: url(" + escape(require("../../../../assets/lp/dot.png")) + ");\n  background-repeat: repeat-x;\n  background-size: 10px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-017174d1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/organisms/chatbot/scenarioEdit/ScenarioEditDownload.vue
// module id = zpn1
// module chunks = 0